module.exports = __webpack_public_path__ + "img/Communication&Neworking.46978f9d.png";